import { parseOmnisearchTokens } from "utils/omnisearchUtils";

/**
 * Base file name for a manifests export, named for a shipped year only when
 * every OR branch of the exported search is bounded to that one year. A
 * correction-date drilldown drops the year picker's scope, so its rows can come
 * from any shipped year.
 */
export function manifestsExportFileName(search: string): string {
  const branches = search.split(" or ").filter((branch) => branch.trim() !== "");
  const branchYears = branches.map(boundShippedYear);
  const [year] = branchYears;
  const oneYear = year !== undefined && branchYears.every((branchYear) => branchYear === year);
  return oneYear ? `waste-manifests-${year}` : "waste-manifests";
}

/** The shipped year a single search branch is bounded to, if exactly one term bounds it. */
function boundShippedYear(branch: string): string | undefined {
  const years = parseOmnisearchTokens(branch).flatMap((token) => {
    const year = /^shippedDate:(\d{4})$/.exec(token)?.[1];
    return year ? [year] : [];
  });
  return years.length === 1 ? years[0] : undefined;
}
